"use strict";
/**
 * This file was auto generated, please do not edit it directly.
 **/

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SitePage = void 0;

var SitePage =
/** @class */
function () {
  function SitePage(restClient) {
    this.restClient = restClient;
  } // Queries

  /**
   * @param string - sitePageId
   * @return Promise|Observable|any
   */


  SitePage.prototype.GetSitePage = function (sitePageId) {
    return this.restClient.get('SitePage/UseCase/GetSitePage', {
      sitePageId: sitePageId
    });
  };
  /**
   * @param string - eventId
   * @param number? - page >= 1
   * @param number? - itemsPerPage 1-100
   * @return Promise|Observable|any
   */


  SitePage.prototype.ListSitePagesForEvent = function (eventId, page, itemsPerPage) {
    if (page === void 0) {
      page = null;
    }

    if (itemsPerPage === void 0) {
      itemsPerPage = null;
    }

    return this.restClient.get('SitePage/UseCase/ListSitePagesForEvent', {
      eventId: eventId,
      page: page,
      itemsPerPage: itemsPerPage
    });
  };
  /**
   * @param string - poolId
   * @param boolean? - shouldIncludeSharedTemplates true|false
   * @param number? - page >= 1
   * @param number? - itemsPerPage 1-500
   * @return Promise|Observable|any
   */


  SitePage.prototype.ListTemplatesForPool = function (poolId, shouldIncludeSharedTemplates, page, itemsPerPage) {
    if (shouldIncludeSharedTemplates === void 0) {
      shouldIncludeSharedTemplates = null;
    }

    if (page === void 0) {
      page = null;
    }

    if (itemsPerPage === void 0) {
      itemsPerPage = null;
    }

    return this.restClient.get('SitePage/UseCase/ListTemplatesForPool', {
      poolId: poolId,
      shouldIncludeSharedTemplates: shouldIncludeSharedTemplates,
      page: page,
      itemsPerPage: itemsPerPage
    });
  }; // Commands

  /**
   * @param string - eventId
   * @param string - title
   * @param string - content
   * @param number? - displayOrder
   * @param string? - sitePageId
   * @param string? - styles
   * @param string? - scripts
   * @param string? - sourceTemplateId
   * @return Promise|Observable|any
   */


  SitePage.prototype.CreateSitePage = function (eventId, title, content, displayOrder, sitePageId, styles, scripts, sourceTemplateId) {
    if (displayOrder === void 0) {
      displayOrder = null;
    }

    if (sitePageId === void 0) {
      sitePageId = null;
    }

    if (styles === void 0) {
      styles = null;
    }

    if (scripts === void 0) {
      scripts = null;
    }

    if (sourceTemplateId === void 0) {
      sourceTemplateId = null;
    }

    return this.restClient.post('SitePage/UseCase/CreateSitePage', {
      eventId: eventId,
      title: title,
      content: content,
      displayOrder: displayOrder,
      sitePageId: sitePageId,
      styles: styles,
      scripts: scripts,
      sourceTemplateId: sourceTemplateId
    });
  };
  /**
   * @param string - name
   * @param string - content
   * @param string - difficulty custom|beginner|intermediate|advanced|expert
   * @param string? - poolId
   * @param string? - styles
   * @param string? - scripts
   * @param string? - description
   * @param string? - templateId
   * @return Promise|Observable|any
   */


  SitePage.prototype.CreateTemplate = function (name, content, difficulty, poolId, styles, scripts, description, templateId) {
    if (poolId === void 0) {
      poolId = null;
    }

    if (styles === void 0) {
      styles = null;
    }

    if (scripts === void 0) {
      scripts = null;
    }

    if (description === void 0) {
      description = null;
    }

    if (templateId === void 0) {
      templateId = null;
    }

    return this.restClient.post('SitePage/UseCase/CreateTemplate', {
      name: name,
      content: content,
      difficulty: difficulty,
      poolId: poolId,
      styles: styles,
      scripts: scripts,
      description: description,
      templateId: templateId
    });
  };
  /**
   * @param string - sitePageId
   * @return Promise|Observable|any
   */


  SitePage.prototype.DisableSearchEngineIndexingForSitePage = function (sitePageId) {
    return this.restClient.post('SitePage/UseCase/DisableSearchEngineIndexingForSitePage', {
      sitePageId: sitePageId
    });
  };
  /**
   * @param string - sitePageId
   * @param string? - newSitePageId
   * @param string? - toEventId
   * @return Promise|Observable|any
   */


  SitePage.prototype.DuplicateSitePage = function (sitePageId, newSitePageId, toEventId) {
    if (newSitePageId === void 0) {
      newSitePageId = null;
    }

    if (toEventId === void 0) {
      toEventId = null;
    }

    return this.restClient.post('SitePage/UseCase/DuplicateSitePage', {
      sitePageId: sitePageId,
      newSitePageId: newSitePageId,
      toEventId: toEventId
    });
  };
  /**
   * @param string - templateId
   * @param string? - newTemplateId
   * @param string? - toPoolId
   * @return Promise|Observable|any
   */


  SitePage.prototype.DuplicateTemplate = function (templateId, newTemplateId, toPoolId) {
    if (newTemplateId === void 0) {
      newTemplateId = null;
    }

    if (toPoolId === void 0) {
      toPoolId = null;
    }

    return this.restClient.post('SitePage/UseCase/DuplicateTemplate', {
      templateId: templateId,
      newTemplateId: newTemplateId,
      toPoolId: toPoolId
    });
  };
  /**
   * @param string - sitePageId
   * @return Promise|Observable|any
   */


  SitePage.prototype.EnableSearchEngineIndexingForSitePage = function (sitePageId) {
    return this.restClient.post('SitePage/UseCase/EnableSearchEngineIndexingForSitePage', {
      sitePageId: sitePageId
    });
  };
  /**
   * @return Promise|Observable|any
   */


  SitePage.prototype.GenerateSitePageTemplates = function () {
    return this.restClient.post('SitePage/UseCase/GenerateSitePageTemplates', {});
  };
  /**
   * @param string - sitePageId
   * @return Promise|Observable|any
   */


  SitePage.prototype.RemoveSitePage = function (sitePageId) {
    return this.restClient.post('SitePage/UseCase/RemoveSitePage', {
      sitePageId: sitePageId
    });
  };
  /**
   * @param string - sitePageTemplateId
   * @return Promise|Observable|any
   */


  SitePage.prototype.RemoveTemplate = function (sitePageTemplateId) {
    return this.restClient.post('SitePage/UseCase/RemoveTemplate', {
      sitePageTemplateId: sitePageTemplateId
    });
  };
  /**
   * @param string - sitePageId
   * @param string - editorJson
   * @param string? - content
   * @param string? - styles
   * @param string? - scripts
   * @return Promise|Observable|any
   */


  SitePage.prototype.SetContentForSitePage = function (sitePageId, editorJson, content, styles, scripts) {
    if (content === void 0) {
      content = null;
    }

    if (styles === void 0) {
      styles = null;
    }

    if (scripts === void 0) {
      scripts = null;
    }

    return this.restClient.post('SitePage/UseCase/SetContentForSitePage', {
      sitePageId: sitePageId,
      editorJson: editorJson,
      content: content,
      styles: styles,
      scripts: scripts
    });
  };
  /**
   * @param string - sitePageId
   * @param string - displayOrder
   * @return Promise|Observable|any
   */


  SitePage.prototype.SetDisplayOrderForSitePage = function (sitePageId, displayOrder) {
    return this.restClient.post('SitePage/UseCase/SetDisplayOrderForSitePage', {
      sitePageId: sitePageId,
      displayOrder: displayOrder
    });
  };
  /**
   * @param string - sitePageId
   * @param string? - title
   * @param string? - description
   * @param string? - keywords
   * @param string? - imageUrl
   * @param string? - name
   * @return Promise|Observable|any
   */


  SitePage.prototype.SetMetaInfoForSitePage = function (sitePageId, title, description, keywords, imageUrl, name) {
    if (title === void 0) {
      title = null;
    }

    if (description === void 0) {
      description = null;
    }

    if (keywords === void 0) {
      keywords = null;
    }

    if (imageUrl === void 0) {
      imageUrl = null;
    }

    if (name === void 0) {
      name = null;
    }

    return this.restClient.post('SitePage/UseCase/SetMetaInfoForSitePage', {
      sitePageId: sitePageId,
      title: title,
      description: description,
      keywords: keywords,
      imageUrl: imageUrl,
      name: name
    });
  };
  /**
   * @param string - sitePageId
   * @param string - title
   * @return Promise|Observable|any
   */


  SitePage.prototype.SetTitleForSitePage = function (sitePageId, title) {
    return this.restClient.post('SitePage/UseCase/SetTitleForSitePage', {
      sitePageId: sitePageId,
      title: title
    });
  };
  /**
   * @param string - sitePageId
   * @param string - eventId
   * @param string - title
   * @param string - content
   * @param number? - displayOrder
   * @return Promise|Observable|any
   */


  SitePage.prototype.UpdateSitePage = function (sitePageId, eventId, title, content, displayOrder) {
    if (displayOrder === void 0) {
      displayOrder = null;
    }

    return this.restClient.post('SitePage/UseCase/UpdateSitePage', {
      sitePageId: sitePageId,
      eventId: eventId,
      title: title,
      content: content,
      displayOrder: displayOrder
    });
  };
  /**
   * @param string - templateId
   * @param string? - name
   * @param string? - content
   * @param string? - poolId
   * @param string? - styles
   * @param string? - scripts
   * @return Promise|Observable|any
   */


  SitePage.prototype.UpdateTemplate = function (templateId, name, content, poolId, styles, scripts) {
    if (name === void 0) {
      name = null;
    }

    if (content === void 0) {
      content = null;
    }

    if (poolId === void 0) {
      poolId = null;
    }

    if (styles === void 0) {
      styles = null;
    }

    if (scripts === void 0) {
      scripts = null;
    }

    return this.restClient.post('SitePage/UseCase/UpdateTemplate', {
      templateId: templateId,
      name: name,
      content: content,
      poolId: poolId,
      styles: styles,
      scripts: scripts
    });
  };

  return SitePage;
}();

exports.SitePage = SitePage;